import React, { useState } from "react";
import MainTemplate from '../mainTemplate';
import Modal from '../../utils/customModal';
import { loadingHtml } from '../../utils/functions';
import PaidRejectedList from '../bill/lists/paidRejected';
import ExpiredBills from '../../../../static/images/expired-bills.svg';

import { ReactTitle } from 'react-meta-tags';

const PaidRejected = () => {

  const [modal, setModal] = useState(true);

  return <MainTemplate className="wrapper-dashboard rejected-bills">
    <ReactTitle title={`Facturas con pagos rechazados - Reverse Factoring`} />

    <div className="header-providers">
      <div className="title">
        <img className="iconList" src={ExpiredBills} style={{ width: '30px' }} />
        <p className="p-list">FACTURAS RECHAZADAS</p>
      </div>
    </div>

    <PaidRejectedList filters={[]} setModal={setModal} />

    <Modal show={modal}>{loadingHtml()}</Modal>
  </MainTemplate>
};

export default PaidRejected;
